// extracted by mini-css-extract-plugin
module.exports = {"about_left":"about-module--about_left--3acR7","about_right":"about-module--about_right--29Oy0","brand":"about-module--brand--36iKl","primary":"about-module--primary--1gUfK"};